import { SingleFileViewerUploadEmptyStateStyled } from './styles/SingleFileViewerUploadEmptyStateStyled'
import EmptyStateSvg from '../../assets/upload-empty-state.svg'
import { useUploadContext } from '@ui/blocks/Upload/UploadContext'
import { InlineTextButton } from '@ui/elements/Button'
import { Space } from '@ui/elements/Space'
import { Text } from '@ui/elements/Text'
import { getAnalyticsDataAttrs } from '@ui/utils/analytics'

export const SingleFileViewerUploadEmptyState = () => {
  const { commonProps } = useUploadContext()

  const { isDisabled, isUploadDisabled, strings, showFileUpload, uploadProps } =
    commonProps

  const analyticsProps = getAnalyticsDataAttrs(
    uploadProps.analyticsIds?.uploadButton
  )

  return (
    <SingleFileViewerUploadEmptyStateStyled>
      <div className='fileviewer-emptystate-container'>
        <Space>
          <img src={EmptyStateSvg} alt='' />

          <>
            <Text bold color='text.placeholder'>
              {strings.uploadEmptyStateText}
            </Text>

            <Text inline color='text.placeholder'>
              {strings.uploadInfo}{' '}
              <InlineTextButton
                type='button'
                disabled={isDisabled || isUploadDisabled}
                onClick={showFileUpload}
                {...analyticsProps}
              >
                {strings.uploadButtonText}
              </InlineTextButton>
            </Text>

            {strings.additionalContext && (
              <Text color='text.placeholder'>{strings.additionalContext}</Text>
            )}
          </>
        </Space>
      </div>
    </SingleFileViewerUploadEmptyStateStyled>
  )
}
